define('drops/iframe/iframe',[
    'jquery',
    'lq',
    'lq/drop',
    'lq/style'
], function ($, lq, Drop, Style) {
    'use strict';

    var defaults = {
        data: {
            source: 'text',
            url: '',
            actionId: '',
            parameters: [],
            eventsToCatch: [],
            scrolling: 'auto'
        }
    };

    function Iframe(options) {
        Drop.call(this, $('<div/>'), defaults, options);
        var self = this;

        this.$iframe = $('<iframe />')
            .attr('scrolling', self.data.scrolling)
            .css({
                width: '100%',
                height: '100%',
                border: 0
            })
            .appendTo(self.$element);
        
        self.$element
	        .addClass('boxToBorderSize')
	        .css({
	            whiteSpace: 'pre-wrap'
	        });

        Style.renderStyles(self);
       
        this.listenForMessage(function(e) {
            // staying backwards compatible with existing custom code
            var args = e.args ? e.args[0] : null;
            self.triggerEvent(self.data.id + '.' + e.eventName, args);
        });

        return self;
    };

    Drop.extend(Iframe, Drop);

    Iframe.typeName = 'Iframe';

    Iframe.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    Iframe.prototype.postRender = function () {
        this.$iframe
            .attr('src', this.getIframeUrl());
    };

    Iframe.prototype.getIframeUrl = function () {
        if (this.data.source === 'text') {
            return this.data.url;
        } 
          
        var parametersForIframe = this.getParametersForIframe();
        var url = lq.getTenantUrl('LicquidAction/Get/' + this.data.actionId);
        return url + '?parameters=' + encodeURIComponent(JSON.stringify(parametersForIframe));
    };

    Iframe.prototype.getParametersForIframe = function () {
        if (!this.data.parameters)
            return {};

        var parameters = this.piping.parameters;
        var parametersForIframe = {};
        _.each(this.data.parameters, function(parameterName) {
            parametersForIframe[parameterName] = parameters.getValue(parameterName);
        });

        return parametersForIframe;
    };

    Iframe.prototype.listenForMessage = function (callback) {
        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        var messageEvent = window.addEventListener ? 'message' : 'onmessage';
        var self = this;

        window[eventMethod](messageEvent, function (e) {
            if (e.source !== self.$iframe.get(0).contentWindow)
                return;
            try {
                var eventObj = JSON.parse(e.data);
                callback(eventObj);
            } catch (err) {
                //could not parse, ignore it
            }

        }, false);
    };

    Iframe.prototype.triggerEventForChild = function (eventObj) { 
        this.$iframe.get(0).contentWindow.postMessage(JSON.stringify(eventObj), "*");
    };

    Iframe.prototype.show = function() {
        this.$iframe
            .css('display', 'inherit');

        Drop.prototype.show.call(this);
    };

    Iframe.prototype.hide = function () {
        // drops that are not visible have 'visibility' set to 'hidden'
        // but in some browser (e.g. Safari) the still block events when hidden
        this.$iframe
            .attr('src', '')
            .css('display', 'none');

        Drop.prototype.hide.call(this);
    };

    return Iframe;
});
